/**
 * API client do pool de certificados de serviço (área admin).
 *
 * Pool de certificados usados na CONSULTA subsidiária de usuários sem
 * certificado próprio (visão pública Res. 121). Proxy para o autenticador via
 * backend. Ver docs/PLANO_CERTIFICADO_SERVICO.md.
 */
import { api } from './client';

export interface CertificadoServicoItem {
  cpf: string;
  rotulo: string | null;
  observacao: string | null;
  titular_nome: string | null;
  numero_serie: string | null;
  valido_ate: string | null;
  certificado_ativo: boolean;
  conexao_pdpj: boolean;
  ativo: boolean;
  usavel: boolean;
  ultimo_uso_em: string | null;
  criado_em: string | null;
  criado_por: string | null;
}

export interface DesignarCertificadoServicoInput {
  cpf: string;
  rotulo?: string | null;
  observacao?: string | null;
}

export interface UploadCertificadoServicoResponse {
  cpf: string;
  titular_nome: string | null;
  numero_serie: string | null;
}

const BASE = '/admin/certificados-servico';

// Upload de PFX + login headless podem demorar dezenas de segundos no autenticador.
const UPLOAD_TIMEOUT_MS = 130_000;

export async function fetchCertificadosServico(): Promise<CertificadoServicoItem[]> {
  const { data } = await api.get<CertificadoServicoItem[]>(BASE);
  return data;
}

export async function designarCertificadoServico(
  input: DesignarCertificadoServicoInput,
): Promise<CertificadoServicoItem> {
  const { data } = await api.post<CertificadoServicoItem>(BASE, input);
  return data;
}

export async function retirarCertificadoServico(cpf: string): Promise<void> {
  await api.delete(`${BASE}/${cpf}`);
}

export async function uploadCertificadoServico(
  file: File,
  senhaCertificado: string,
): Promise<UploadCertificadoServicoResponse> {
  const form = new FormData();
  form.append('arquivo', file);
  form.append('senha_certificado', senhaCertificado);
  const { data } = await api.post<UploadCertificadoServicoResponse>(
    `${BASE}/upload-certificado`,
    form,
    { timeout: UPLOAD_TIMEOUT_MS },
  );
  return data;
}

export async function uploadOtpCertificadoServico(cpf: string, file: File): Promise<void> {
  const form = new FormData();
  form.append('cpf', cpf);
  form.append('arquivo', file);
  await api.post(`${BASE}/upload-otp`, form, { timeout: UPLOAD_TIMEOUT_MS });
}
